module.exports = () => ({
  school: 'PHHS',
  inProcess: false,
  loggedIn: false,
  domainError: false,
  invalidCredentials: false,
  timeout: false,
  systemError: false,
  id_token: '',
  user: null,
  activePage: 'lopStatus',

  studentObjs: {},
  selectedStuID: null,

  reasons: []
})



// WEBPACK FOOTER //
// ./src/store/initState.js